import {
  loginError,
  loginSuccess,
  logoutSuccess,
  headingData,
} from "./reducer";
import { ThunkAction } from "redux-thunk";
import { Action, Dispatch } from "redux";
import { RootState } from "slices";
import callApi from "Common/utils/apiCaller";

interface User {
  email: string;
  password: string;
}

export const loginUser =
  (
    user: User,
    history: any
  ): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      let res = await callApi("v1/admin/login", "post", {
        admin: { contact_email: user.email, password: user.password },
      });

      if (res.data.status === "Success") {
        localStorage.setItem(
          "authUser",
          JSON.stringify({
            ...res.data.data.admin,
            token: res.data.data.token,
          })
        );
        dispatch(loginSuccess(res.data.data.admin));
        dispatch(headingData(res.data.data.admin));
        history("/");
      }
    } catch (error) {
      dispatch(loginError(error));
    }
  };

export const logoutUser = () => async (dispatch: Dispatch) => {
  try {
    localStorage.removeItem("authUser");
    dispatch(logoutSuccess(true));
  } catch (error) {
    dispatch(loginError(error));
  }
};
